module.exports = __webpack_public_path__ + "img/logo_redondo.e00560c8.png";